var uAjax = "/index.cfm/transaction/ajax";

// Function to check cera validation state and enable/disable button accordingly
function checkCeraValidationState() {
	if ($('#ceraForm').length > 0) {
		// Count only filled fields that need validation
		var filledFieldsCount = 0;
		$('.edtCeraNumber').each(function() {
			if ($(this).val() !== '') {
				filledFieldsCount++;
			}
		});
		
		var validatedFieldsCount = $('.ceraValidIcon').length;
		
		// Enable if all filled fields are validated
		if (filledFieldsCount > 0 && validatedFieldsCount === filledFieldsCount) {
			enableTransactionSubmit();
		}
		// Disable if:
		// 1. No fields are filled yet (user hasn't validated anything)
		// 2. Some fields are filled but not all are validated
		else if (validatedFieldsCount === 0 || (filledFieldsCount > 0 && validatedFieldsCount < filledFieldsCount)) {
			disableTransactionSubmit();
		}
	}
}

$(function()
{
	// Hide webcode field on load
	$(el('edtWebCode')).closest('.control-group').hide();

	// Check cera validation state on page load
	checkCeraValidationState();

	// show popup for finalize error
  	if(bStockError === true)
 	{
		showAlert('error', sStockErrorMessage, false);
  	}

	if(sTransactionIndexErrorMessage !== "")
 	{
		showAlert('error', sTransactionIndexErrorMessage, false);
  	}

  	var oBasket = $(el('mainContainer'));
	// change quantity listeners
	oBasket.on('click', '.qtyMin', function()
	{
		changeQty($(this).next(), 'min');
		return false;
	});
	oBasket.on('click', '.qtyPlus', function()
	{
		changeQty($(this).prev(), 'plus');
		return false;
	});
	oBasket.on('change', '.edtQty', function()
	{
		var oEdtQty = $(this);
		var sLineId = oEdtQty.attr("line-id");

		if(oEdtQty.val() == 0){
			removeLine(sLineId);
		}
		else
		{
			checkMultiplier(oEdtQty);
			validateQty(oEdtQty.val(), sLineId);
		}
	});
	oBasket.on('click', '.btnRefresh', function()
	{
		var oEdtQty = $(this).closest('tr').find('.edtQty');
		var sLineId = $(this).attr("line-id");

		checkMultiplier(oEdtQty);
		validateQty(oEdtQty.val(), sLineId);
	});

	// remove transaction line listener
	oBasket.on('click', '.btnRemove', function()
	{
		askRemoveLine($(this).attr("line-id"));
	});

	oBasket.on('click', '#removeLine', function()
	{
		removeLine($(this).attr("line-id"));
	});

	// cancel full transaction
	oBasket.on('click', '#cancelFullOrderBtnId', function()
	{
		$('#cancelOrderModal').modal('toggle');
	});

	// giftvoucher form listener
	oBasket.on('click', '#addGiftVoucher', function()
	{
		var sInputValue = $(el('edtVoucher')).val();
		var sInputWebCodeValue = $(el('edtWebCode')).val();
		var bWebcodeAlwaysVisible = ($('.webcodeAlwaysVisible').length > 0);
		sInputValue = (bRemoveSpacesFromVoucherReferenceInput) ? sInputValue.trim().replaceAll(" ","") : sInputValue;
		sInputWebCodeValue = (bRemoveSpacesFromVoucherReferenceInput) ? sInputWebCodeValue.trim().replaceAll(" ","") : sInputWebCodeValue;
		if($('#edtWebCode').is(":visible") && !bWebcodeAlwaysVisible)
		{
			if(fieldIsValid($('#edtWebCode')))
			{
				submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
			}
			else
			{
				setFieldValidationState($('#edtWebCode'),'error');
			}
		}
		else
		{
			if(bWebcodeAlwaysVisible) {
				if (sInputWebCodeValue == '' && sInputValue == '') {
					setFieldValidationState($('#edtVoucher'),'error');
				} else if ($('.webcodeAlwaysVisible').prop('required') && sInputWebCodeValue == '') {
					setFieldValidationState($('#edtVoucher'),'success');
					setFieldValidationState($('#edtWebCode'),'error');
				} else {
					submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
				}
			} else {
				submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
			}
		}

		return false;
	});

	// promo form listener
	oBasket.on('click', '#addPromoCode', function()
	{
		submitGiftVoucher($(el('edtPromoCode')).val().toUpperCase(),'');

		return false;
	});

	// remove giftvoucher listener
	oBasket.on('click', '.icon-remove', function()
	{
		if($(this).hasClass('promoCode')){
			removePromoCode($(this).data('promocodeId'));
		}
		else
		{
			removeGiftVoucher($(this).data('paymentId'));
		}
		return false;
	});

	preventNegativeValue();

	$('.input-quantity').keyup(function()
	{
		makePositiveValue($(this));
	});

	oBasket.on('click', '.campainLink', function() {
		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		addFeaturedProduct(sSku, 1, sShopId, sCollectMethod);
		return false;
	});

	// Add product to basket (home delivery)
	oBasket.on('click','.checkoutCampaignPopupAddSku', function(e)
	{
		e.preventDefault();

		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		addFeaturedProduct(sSku, 1, sShopId, sCollectMethod);
		return false;
	});

	oBasket.on('click','.checkoutCampaignPopupAddConfiguration', function(e)
	{
		e.preventDefault();

		var sCollectMethod = $(this).data('collectMethod');
		var sShopId        = $(this).data('shopId');
		var sSku           = $(this).data('skuId');
		var sWebname       = $(this).data('webname');

		if(sSku)
		{
			var oSelectedSku = {};
			oSelectedSku.description = sWebname;
			oSelectedSku.quantity    = 1;
			oSelectedSku.skuId       = sSku;

			var addons = getSelectedAddons();
			addons.push(oSelectedSku);

			sAddons = JSON.stringify(addons);
			addFeaturedConfiguration(oSelectedSku.skuId,oSelectedSku.quantity,sShopId,sCollectMethod,sAddons);
		}
		return false;
	});

	oBasket.on('click', '.qtyBtn', function(e) {
		e.preventDefault();

		var oEdtQty    = $(this).parents('.priceData').find('.edtQty');

		var iCurrentVal = parseInt(oEdtQty.val());
		var iMultiplier = parseInt(oEdtQty.data('qtyMultiplier'));
		var sType      = $(this).attr('data-type');

		if (!isNaN(iCurrentVal))
		{
			if(sType === 'minus')
			{
				if(iCurrentVal > oEdtQty.attr('min'))
				{
					oEdtQty.val(iCurrentVal - (1*iMultiplier)).change();
				}
			}
			else if(sType === 'plus')
			{
				oEdtQty.val(iCurrentVal + (1*iMultiplier)).change();
			}
		}
	});

	oBasket.on('click', '.btnToCheckout,.offsetFreeDelivery', function(e) {
		e.preventDefault();

		// Prevent checkout if button is disabled (e.g., cera validation required)
		if ($(this).hasClass('disabled')) {
			return false;
		}

		if($(el('offsetForFreeDeliveryModal')).length)
		{
			promptOffsetForFreeDeliveryModal()
		}
		else
		{
			window.location = this.href;
		}
	});

	oBasket.on('hide', '#offsetForFreeDeliveryModal', function()
	{
		window.location = $('.btnToCheckout').attr('href');
	});

	if($(window).width() < 768)
	{
		$(el('offsetForFreeDeliveryModal')).one('shown', function()
		{
			$('.featuredproducts .flexslider').each(function(index){
				$(this).flexslider({
					animation: "slide",
					animationLoop: false,
					controlNav: false,
					itemMargin: 0,
					slideshow: false,
					touch: true
				});
			});
			centerPopups();
		});
	}

	oBasket.on('change keyup', '#edtVoucher', function(e)
	{
		var sInput = $(el('edtVoucher')).val().toLowerCase().replace(/\s/g,'');
		if(sInput.length > 1)
		{
			// Check if code starts with voucher prething
			var aListVoucher = ["gft","loy","cv","vrn","0000"];
			matched = false;
			for(i=0; i<= aListVoucher.length; i++)
			{
				if(sTenantId === 175 && (sInput === "0000000000215" || sInput === "0000000000284"))
				{
					$(el('edtWebCode')).closest('.control-group').hide();
				}
				else if(sInput.indexOf(aListVoucher[i]) == 0)
				{
					$(el('edtWebCode')).closest('.control-group').show();
					$('.webcodeAlwaysVisible').prop('required', true);
					matched = true;
					break;
				} else {
					$('.webcodeAlwaysVisible').prop('required', false);
				}
			}
			if(!matched)
			{
				// Check years
				if(sInput.length > 3)
				{
					var checkYear = parseInt(sInput.substring(0,4));
					if(!isNaN(parseFloat(checkYear)) && isFinite(checkYear))
					{
						if(checkYear > 2000 && checkYear < 3000)
						{
							// it is a year
							$(el('edtWebCode')).closest('.control-group').show();
						}
					}
					else
					{
						$(el('edtWebCode')).closest('.control-group').hide();
					}
				}
				else
				{
					$(el('edtWebCode')).closest('.control-group').hide();
				}
			}
		}
		else
		{
			$(el('edtWebCode')).closest('.control-group').hide();
		}
	});

	oBasket.on("click", ".entryPreview", function(e)
	{
		var oEntryPreviewBtn = $(this);
		if(oEntryPreviewBtn.hasClass('loaded'))
		{
			oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages a").first().trigger("click");
		}
		else
		{
			oEntryPreviewBtn.addClass("loading");
			sEntryId = oEntryPreviewBtn.data('entryId');

			oCall = entryPreview(sEntryId);
			oCall.success(function(oData)
			{
				oEntryPreviewBtn.removeClass("loading");

				if(oData.errorMessage == "" && typeof oData.entry !== "undefined" && typeof oData.entry.result !== "undefined" && oData.entry.result.length > 0)
				{
					oEntryPreviewBtn.addClass('loaded');
					$.each(oData.entry.result, function( index, value ) {
						oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages").append('<a href="' + value + '" data-fancybox="' + sEntryId + '"></a>');
					});
					oEntryPreviewBtn.parents(".entryPreviewWrapper").find(".entryPreviewImages a").first().trigger("click");
				}
				else
				{
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
	});

	// Validate Cera numbers button click
	oBasket.on('click','#btnValidateCera', function(e)
	{
		e.preventDefault();
		saveCeraNumbers($(el("ceraForm")));
	});

	// Clear validation icons when user types
	oBasket.on('input','.edtCeraNumber', function(e)
	{
		$('.ceraValidIcon').remove();
		// Disable transaction submit until validated
		disableTransactionSubmit();
	});

	oBasket.on('click','#askClearBasket', function(e)
	{
		askClearBasket();
	});

	oBasket.on('click','#clearBasket', function(e)
	{
		clearBasket();
	});


	init();
	if(bEnableCalcDeliveryPromise) calcDeliveryPromise();
});

function askClearBasket()
{
	var oPopup = $('#popupContinue');
	setAction(oPopup, 'clearBasket', {});
	setPopupHeader(oPopup, sAskClearBasketTitle, '');
	oPopup.find('.modal-body .content').html(sAskClearBasketContent);

	oPopup.find('.modal-footer .action').addClass("btn-alternate").html(sAskClearBasketConfirm);
	oPopup.find('.modal-footer .cancel').addClass("btn-primary").html(sCancel);

	oPopup.modal();
}

function clearBasket()
{
	var oCall = callAjax("clearBasket", "", "post","/index.cfm/transaction/ajax/clearBasket");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			$(el('popupContinue')).modal('hide');
			$(el('mainContent')).html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();

			getBasketDropdownHeader();

			init();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function saveCeraNumbers(oFrm)
{
	// Disable button during validation
	$('#btnValidateCera').prop('disabled', true).text('Validating...');
	
	var sParams = getValues(oFrm);
	var oCall = callAjax("saveCeraNumbers", sParams, "post","/index.cfm/transaction/ajax/saveCeraNumbers");
	// process feedback
	oCall.success(function(oData)
	{
		// Re-enable button
		$('#btnValidateCera').prop('disabled', false).text($('#btnValidateCera').data('original-text') || 'Validate');
		
		if(oData.errorType == '')
		{
			// Remove any existing icons first to avoid duplicates
			$('.ceraValidIcon').remove();
			
			// Validation successful - show check icons and enable submit
			$('.edtCeraNumber').each(function() {
				if($(this).val() !== '') {
					$(this).parent().append('<i class="far fa-check-circle ceraValidIcon"></i>');
				}
			});
			enableTransactionSubmit();
		}
		else
		{
			// show error message and keep submit disabled
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			disableTransactionSubmit();
		}
	});
}

function enableTransactionSubmit()
{
	// Only control submit button if cera form exists
	if ($('#ceraForm').length > 0) {
		$('.transaction .btnToCta, .transaction .btnToCheckout').removeClass('disabled').css('pointer-events', 'auto').prop('disabled', false);
		
		// Also enable buttons inside links to checkout
		$('a[href*="/transaction/checkout"]').removeClass('disabled').css('pointer-events', 'auto');
		$('a[href*="/transaction/checkout"] button').prop('disabled', false);
	}
}

function disableTransactionSubmit()
{
	// Only control submit button if cera form exists
	if ($('#ceraForm').length > 0) {
		$('.transaction .btnToCta, .transaction .btnToCheckout').addClass('disabled').css('pointer-events', 'none').prop('disabled', true);
		
		// Also disable buttons inside links to checkout
		$('a[href*="/transaction/checkout"]').addClass('disabled').css('pointer-events', 'none');
		$('a[href*="/transaction/checkout"] button').prop('disabled', true);
	}
}

function addFeaturedConfiguration(sSku, iQty, sShopId, sCollectMethod,sAddons)
{
	// Set loader
	var sParams = '&mainSkuId=' + sSku
				+ '&mainSkuQty=' + iQty
				+ '&shopId=' + sShopId
				+ '&collectMethodId=' + sCollectMethod
				+ '&addons=' + encodeURIComponent(sAddons);
	var oCall = callAjax("addConfiguration", sParams, "post");
	// process feedback
	oCall.success(function(oData)
	{
		$('.checkoutCampaignPopup').modal('hide');

		if(oData.errorType == '')
		{
			// Add to basket successful
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();

			init();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function addFeaturedProduct(sSku, iQty, sShopId, sCollectMethod)
{
	// Set loader
	var sParams = '&skuId=' + sSku
				+ '&qty=' + iQty
				+ '&idShop=' + sShopId
				+ '&collectMethodId=' + sCollectMethod
				+ '&customHtml=index';
	var oCall = callAjax("addSku", sParams, "post");
	// process feedback
	oCall.success(function(oData)
	{
		$('.checkoutCampaignPopup').modal('hide');

		if(oData.errorType == '')
		{
			// Add to basket successful
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();

			init();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function askRemoveLine(sLineId)
{
	var oPopup = $('#popupContinue');

	setAction(oPopup, 'removeLine', {'line-id': sLineId});
	setPopupHeader(oPopup, sAskRemoveLineTitle, '');
	oPopup.find('.modal-body .content').html(sAskRemoveLineContent);

	oPopup.find('.modal-footer .action').html(sAskRemoveLineConfirm);
	oPopup.find('.modal-footer .cancel').html(sAskRemoveLineCancel);

	oPopup.modal();
}

function calcDeliveryPromise()
{
	clearErrors();

	// AJAX call
	var oCall   = callAjax("calcDeliveryPromise", "", "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$(el('mainContent')).html(oData.html);

			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();

			// refresh basket dropdown
			getBasketDropdownHeader();

			init();
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function changeLineQty(sLineId, iQty)
{
	clearErrors();

	var buttons = $('[line-id=' + sLineId + ']').parent().find('.qtyBtn');
	buttons.each(function(){
		$(this).prop('disabled', true);
	});

	// AJAX call
	var sParams = '&lineId=' + sLineId + '&lineQty=' + iQty;
	var oCall   = callAjax("changeLineQty", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '' || oData.errorType === 'qtyChangedByStock')
		{
			$(el('mainContent')).html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();

			if (oData.errorType === 'qtyChangedByStock')
			{
				showAlert('warning', tStockErrorSku || oData.errorMessage, false, 8000);
			}
			else if($('[line-id=' + sLineId + ']').parents('.line-wrapper').length > 0)
			{
				if (oData.quantityError) {
					$('[line-id=' + sLineId + ']').parents('.productLine').parent().css('position', 'relative');
					inlineAlert('warning productLineWarning', tMinQuantityChanged, false, $('[line-id=' + sLineId + ']').parents('.productLine'),false,null,true,null);
				} else {
					inlineAlert('warning', tQuantityChanged, false, $('[line-id=' + sLineId + ']').parents('.line-wrapper'),false);
				}
			}
			else
			{
				showAlert('warning', tQuantityChanged, false, '1000');
			}

			// refresh basket dropdown
			getBasketDropdownHeader();

			init();

			if(typeof voyadoEnabled !== "undefined" && voyadoEnabled)
			{
				$(document).trigger(oData.functionVoyado,[oData.cartVoyado]);
			}
		}
		else if(oData.errorType === 'EMaximumOrderQuantityReached')
		{
			var iMaxOrderQuantity = $('[line-id=' + sLineId + ']').data("max-order-quantity");
			if(typeof iMaxOrderQuantity != "undefined") $('[line-id=' + sLineId + ']').val(iMaxOrderQuantity);

			if($('[line-id=' + sLineId + ']').parents('.line-wrapper').length > 0)
			{
				inlineAlert('error', oData.errorMessage, false, $('[line-id=' + sLineId + ']').parents('.line-wrapper'),false);
			}
			else
			{
				showAlert('error', oData.errorMessage, false, '1000');
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.ajaxLoader').fadeOut(200);

		buttons.each(function(){
			$(this).prop('disabled', false);
		});
	});
}

function changeQty(edtQty, type)
{
	if (type == 'plus') {
		if (edtQty.prop('value') < 9999) {
			edtQty.prop('value', parseInt(edtQty.prop('value')) + 1);
		}
	} else {
		if (edtQty.prop('value') > 1) {
			edtQty.prop('value', parseInt(edtQty.prop('value')) - 1);
		}
	}

	$(edtQty).trigger('change');
}

function disableQtyEdit()
{
	var arraySerialRequiredLines = JSON.parse(aSerialRequiredLines)
	$(arraySerialRequiredLines).each(function(i,el)
	{
		var oInput = $('.edtQty[line-id*=' + el + ']');
		oInput.prop('disabled', true);
		oInput.parents('.input-prepend.input-append').find('.qtyBtn').prop('disabled', true);
	});
}

function entryPreview(sEntryId)
{
	var sParams = '&entryId=' + sEntryId;

	return callAjax("entrypreview", sParams, "post", "/index.cfm/product/ajax/entrypreview");
}

function init()
{
	disableQtyEdit();
	initLazyResponsiveLoad();
	if (typeof initFlexSliders === "function") initFlexSliders();
	if (typeof initFeaturedProducts === "function") initFeaturedProducts();
	if (typeof initFeaturedProductsGridSlider === "function") initFeaturedProductsGridSlider();
	if (typeof initForms === "function") initForms();
	if (typeof initContentEventHandlers === "function") initContentEventHandlers();
	if (typeof initHotSpotImages === "function") initHotSpotImages();
	if (typeof initPaymentOptions === "function") initPaymentOptions();
	ciResponsive.process();
}

function preventNegativeValue()
{
	var quantityField = $(".input-quantity");

	quantityField.keypress(function(event)
	{
		if ( event.which == 45 ) {
			event.preventDefault();
		}
	});

}
function makePositiveValue(element)
{
	var quantityFieldValue = element.val();
	var positiveValue = Math.abs(quantityFieldValue);
	element.val(positiveValue);
}

function promptOffsetForFreeDeliveryModal()
{
	$(el('offsetForFreeDeliveryModal')).modal('show');
}

function removeGiftVoucher(sPaymentId)
{
	var sParams = '&paymentId=' + sPaymentId;
	var oCall   = callAjax("removePayment", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			location.reload(true);
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function removeLine(lineId) {
	var sParams = '&lineId=' + lineId;
	var oCall = callAjax("deleteLine", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType == '')
		{
			$('#popupContinue').modal('hide');
			showAlert('info', tLineRemoved, false, 4000);
			$('#mainContent').html(oData.html);
			$(el('edtWebCode')).closest('.control-group').hide();
			checkCeraValidationState();
			getBasketDropdownHeader();

			init();

			$(document).trigger( "removeLine",[lineId]);

			if(typeof voyadoEnabled !== "undefined" && voyadoEnabled)
			{
				$(document).trigger(oData.functionVoyado,[oData.cartVoyado]);
			}
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.ajaxLoader').fadeOut(200);
	});
}

function removePromoCode(sPromoCodeId)
{
	var sParams = '&promoCodeId=' + sPromoCodeId;
	var oCall   = callAjax("removePromoCode", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			location.reload(true);
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});

}

function submitGiftVoucher(sGiftVoucher, sWebCode)
{
	if($.trim(sWebCode) === '')
	{
		sWebCode = '000';
	}
	var sParams = '&giftvoucher=' + encodeURIComponent(sGiftVoucher) + '&webcode=' + sWebCode;

	var oCall   = callAjax("addGiftVoucher", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			location.reload(true);
		}
		else
		{
			if(oData.errorType === 'EVoucherInvalidWebcode')
			{
				showAlert('error', tInvalidWebcode, oData.errorUnhandled,3000);
			}
			else if(oData.errorType === 'EVoucherCannotBeValidatedWithoutWebCode')
			{
				showAlert('error', tEmptyWebcode, oData.errorUnhandled,3000);
			}
			else {
				showAlert('error', oData.errorMessage, oData.errorUnhandled,3000);
			}
		}
	});
}

function validateQty(iQty, sLineId)
{
	if(isNaN(iQty) !== true && iQty != ""){
		iQty = Math.abs(iQty);
		changeLineQty(sLineId, iQty);
	}
}

function checkMultiplier(qtyInput)
{
	var qty = parseInt(qtyInput.val());
	var multiplier = parseInt(qtyInput.data('qtyMultiplier'));

	if(typeof qtyInput.data('min') !== 'undefined')
	{
		var minQty = parseInt(qtyInput.data('min'));
		if(qty < minQty)
		{
			qty = minQty;
			qtyInput.val(qty);
		}
	}
	if(multiplier > 1)
	{
		if(qty < multiplier)
		{
			qtyInput.val(multiplier);
		}
		else
		{
			var diffQty = (qty % multiplier);
			if(diffQty !== 0)
			{
				var newQty = Math.ceil(qty/multiplier) * multiplier;
				qtyInput.val(newQty);
			}
		}
	}
}


// Additional Info / Samples Modal functionality
$(function() {
	var oBasket = $(el('mainContainer'));
	
	// Open additional info modal
	oBasket.on('click', '.editAdditionalInfo', function() {
		if (typeof centerPopups === 'function') {
			centerPopups();
		}
	});

	// Save additional info
	oBasket.on('click', '#saveAdditionalInfo', function(e) {
		e.stopPropagation();
		var sAdditionalInfo = (typeof $('.inputAdditionalInfo').val() != "undefined") ? $('.inputAdditionalInfo').val() : "";
		var sExternalReference = (typeof $('.inputExternalReference').val() != "undefined") ? $('.inputExternalReference').val() : "";

		updateAdditionalInfo(sAdditionalInfo, sExternalReference);
		return false;
	});

	// Remove additional info
	oBasket.on('click', '.btnRemoveAdditionalInfo', function(e) {
		e.preventDefault();
		// Clear both fields by saving empty values
		updateAdditionalInfo('', '');
		return false;
	});
});

function updateAdditionalInfo(sAdditionalInfo, sExternalReference) {
	uAjax = "/index.cfm/transaction/ajax/changeadditionalinfo";
	var sParams = "&transactionId=" + transactionId + "&additionalInfo=" + encodeURIComponent(sAdditionalInfo) + "&externalReference=" + encodeURIComponent(sExternalReference);
	var oCall = callAjax('changeadditionalinfo', sParams, 'POST', uAjax);
	oCall.success(function(oData) {
		if(oData.ErrorType === '') {
			$(el('additionalInfo')).modal('hide');
			// Ensure backdrop is removed
			$('.modal-backdrop').remove();
			$('body').removeClass('modal-open');
			
			// Update cart page display if container exists
			if($('#additionalInfoDisplayContainer').length > 0) {
				updateCartAdditionalInfoDisplay(sAdditionalInfo, sExternalReference);
			}
		} else {
			if (typeof showAlert === 'function') {
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		}
	});
}

function updateCartAdditionalInfoDisplay(sAdditionalInfo, sExternalReference) {
	var hasInfo = (sAdditionalInfo && sAdditionalInfo.trim() !== '') || (sExternalReference && sExternalReference.trim() !== '');
	var container = $('#additionalInfoDisplayContainer');
	
	if (hasInfo) {
		var infoText = '';
		if (sAdditionalInfo && sAdditionalInfo.trim() !== '') {
			infoText += sAdditionalInfo;
		}
		if (sExternalReference && sExternalReference.trim() !== '') {
			if (infoText !== '') {
				infoText += ' - ';
			}
			infoText += sExternalReference;
		}
		
		var html = '<div class="row additionalInfoRow">' +
			'<div class="span12">' +
			'<div class="additionalInfoDisplay">' +
			'<button class="btn btn-small btn-danger btnRemoveAdditionalInfo" data-title="Remove" data-placement="top">' +
			'<i class="fa fa-trash"></i>' +
			'</button>' +
			'<span class="additionalInfoText">' +
			'<strong>' + (typeof tSamples !== 'undefined' ? tSamples.toUpperCase() : 'SAMPLES') + ':</strong> ' +
			'<span class="transactionAdditionalInfo">' + infoText + '</span>' +
			'</span>' +
			'</div>' +
			'</div>' +
			'</div>';
		
		container.html(html);
	} else {
		container.html('');
	}
}
